<template>
  <div class="messageList">
    <div class="list">
      <div
        class="list_item"
        v-for="(item, index) in noticeList"
        :key="index"
        @click="toActiveDetail(item, index)"
        v-show="index < currentPage * size"
      >
        <div class="list_item_l">
          <img
            class="list_item_icon"
            :src="item.isNew ? read : unRead"
            alt=""
          />
          <span class="list_item_title">{{ item.title }}</span>
        </div>
        <span class="li_time">{{ item.addTimeStr }}</span>
      </div>
    </div>
    <div class="paginationBox">
      <span class="sizeTip" v-if="noticeList.length == 0">暂无信息展示</span>
      <span class="sizeTip" v-else-if="noticeList.length <= size * currentPage"
        >已显示全部</span
      >
      <span
        class="sizeTip"
        v-else-if="noticeList.length > size * currentPage"
        @click="getMore"
        >显示更多</span
      >
      <!-- <van-pagination
        v-else
        v-model="currentPage"
        :items-per-page="size"
        :total-items="noticeList.length"
      /> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "messageList",
  props: ["list", "showType", "pageSize"],
  components: {},
  data() {
    return {
      noticeList: [],
      read: require("../assets/img/notice_normal.png"),
      unRead: require("../assets/img/notice_sel.png"),
      type: "",
      currentPage: 1,
      size: 6,
    };
  },
  created() {
    if (this.list) {
      this.noticeList = this.list;
    }
    if (this.showType) {
      this.type = this.showType;
    }
    if (this.pageSize) {
      this.size = this.pageSize;
    }
  },
  mounted() {
    this.noticeList = this.list;
    this.type = this.showType;
    if (this.pageSize) {
      this.size = this.pageSize;
    }
  },
  watch: {
    list() {
      this.noticeList = this.list;
    },
    showType() {
      this.type = this.showType;
    },
    pageSize() {
      this.size = this.pageSize;
    },
    currentPage() {},
  },
  mounted() {},
  methods: {
    getMore() {
      let page = this.currentPage;
      if (this.size * page > this.noticeList.length) {
        return false;
      }
      this.currentPage = page + 1;
    },
    toActiveDetail(item) {
      if (this.type == "notice" || item.msgType == 1) {
        this.getNoticeDetailFun(item);
      } else if (this.type == "strategy" || item.msgType == 2) {
        this.getStrategyDetailFun(item);
      } else if (item.msgType == 0) {
        this.getActivityInfoFun(item);
      }
    },
    getNoticeDetailFun(v) {
      let data = {
        bulletinId: v.id,
      };
      this.$api.reqData("/api/v1/index/getBulletinInfo", data).then(
        (res) => {
          if (res.code == 200) {
            if (v.isNew == 0) {
              this.changeList(v.id);
            }
            this.$store.dispatch("GetDetailMsgFun", JSON.stringify(res.data));
            this.$store.dispatch("IsShowDetailFun", true);
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    getStrategyDetailFun(v) {
      let data = {
        strategyId: v.id,
      };
      this.$api.reqData("/api/v1/index/getStrategyInfo", data).then(
        (res) => {
          if (res.code == 200) {
            if (v.isNew == 0) {
              this.changeList(v.id);
            }
            this.$store.dispatch("GetDetailMsgFun", JSON.stringify(res.data));
            this.$store.dispatch("IsShowDetailFun", true);
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    getActivityInfoFun(v) {
      let data = {
        activityId: v.id,
      };
      this.$api.reqData("/api/v1/index/getActivityInfo", data).then(
        (res) => {
          if (res.code == 200) {
            if (v.isNew == 0) {
              this.changeList(v.id);
            }
            this.$store.dispatch("GetDetailMsgFun", JSON.stringify(res.data));
            this.$store.dispatch("IsShowDetailFun", true);
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    changeList(id) {
      let data = this.noticeList;
      this.noticeLis = data.map((item) => {
        if (item.id == id) {
          return item.isNew = 1;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.messageList {
  @include flex_box(column, none, stretch);
  height: 100%;
  .list {
    @include flex_box(column, none, stretch);
  }
  .list_item {
    // height: 0.66rem;
    padding:.14rem 0;
    border-bottom: 1px solid #ededed;
    @include flex_box(row, space-between, center);
    font-size: 12px;
    color: #656565;
  }

  .list_item_l {
    @include flex_box(row, flex-start, center);
    font-size:14px ;
    flex:1;
  }
  .list_item_title{
    text-align: left;
  }
  .list_item_icon {
    width: 0.3rem;
    height: auto;
    margin-right: 0.06rem;
  }
  .li_time {
    margin-left: .1rem;
    width:auto;
    padding:0 .1rem;
    color: #999999;
    // transform: scale(0.9);
    // transform-origin: end center;
  }
  .paginationBox {
    margin-top: .1rem;
    width: 100%;
    @include flex_box(row, center, center);
    height: .6rem;
  }
  .sizeTip {
    font-size: 0.24rem;
    color: #ff913a;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/messageList.vue